import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { getUrlLink,getTestUrlLink } from '../api/index.js';

Vue.use(Router)

const routes = [{
  path: '/',
  name: 'index',
  component: () => import('@/views/index.vue'),
},{
  path: '*',
  name: 'index',
  component: () => import('@/views/index.vue'),
}
]
const router = new Router({
  mode: 'history',
  routes: routes
})
router.beforeEach((to,from,next) => {
  if(to.query.p){
    // 测试环境
    getTestUrlLink({code:to.query.p}).then((res) => {
      store.commit('SET_URL',res.data.url)
      window.location.href = res.data.url
    }).catch((e) => {
      next('/')
    })
  }else if (/^\/\d{1,8}$/.test(to.path)) {
    const code = to.path.slice(1)
    getUrlLink({code}).then((res) => {
      store.commit('SET_URL',res.data.url)
      window.location.href = res.data.url
    }).catch((e) => {
      next('/')
    })
  } else {
    next()
  }
})
export default router
